/* eslint-disable */

import VotingDapp from './VotingDapp';
import ElectionFactory from './ElectionFactory';
import abi from './abi';
const requiredAllowance = '2000';
export {
  ElectionFactory,
  abi,
  requiredAllowance,
};